import _ from 'lodash';
import {
  CA_POSTAL_REGEX,
  ZIP_REGEX,
  LOCATION_COOKIE,
  CODE_TYPE_CUST_LOCATION,
  CODE_TYPE_AKAMAI,
  CODE_TYPE_FALLBACK,
  CODE_TYPE_URL,
} from '../../constants';

const GMWP_COOKIE = 'GMWP_location';

import {
  getCookie,
  getCookieObject,
  putCookieObject,
} from '../../utils/cookieHelpers/cookieHelpers';

function validatePostalCode(postalCode, country) {
  if (country === 'CA') {
    return CA_POSTAL_REGEX.test(postalCode);
  }

  if (country === 'US') {
    return ZIP_REGEX.test(postalCode);
  }
}

export const getPostalCode = (
  country,
  brand,
  postalCodeURLParam,
  shopperLinkPostalCodeUrlParam,
  zipCodeUrl
) => {
  if (postalCodeURLParam && validatePostalCode(postalCodeURLParam, country)) {
    setCustomerLocationCookie(postalCodeURLParam, country, brand, zipCodeUrl);

    return {
      value: postalCodeURLParam,
      isDefault: false,
      codeType: CODE_TYPE_URL,
    };
  }

  const customerLocation = getCookieObject(LOCATION_COOKIE);

  if (
    customerLocation &&
    validatePostalCode(customerLocation.zipcode, country)
  ) {
    return {
      value: customerLocation.zipcode,
      isDefault: false,
      codeType: CODE_TYPE_CUST_LOCATION,
    };
  }

  if (
    shopperLinkPostalCodeUrlParam &&
    validatePostalCode(shopperLinkPostalCodeUrlParam, country)
  ) {
    setCustomerLocationCookie(
      shopperLinkPostalCodeUrlParam,
      country,
      brand,
      zipCodeUrl
    );

    return {
      value: shopperLinkPostalCodeUrlParam,
      isDefault: false,
      codeType: CODE_TYPE_URL,
    };
  }

  const gmwpLocation = getCookie(GMWP_COOKIE);

  if (gmwpLocation) {
    const akamaiPostalCode = _.first(
      _.last(gmwpLocation.split(',')).replace('zip=', '').split(/[-+]+/)
    );

    if (akamaiPostalCode && validatePostalCode(akamaiPostalCode, country)) {
      setCustomerLocationCookie(akamaiPostalCode, country, brand, zipCodeUrl);
      return {
        value: akamaiPostalCode,
        isDefault: false,
        codeType: CODE_TYPE_AKAMAI,
      };
    }
  }

  //fallbacks by country
  if (country === 'US') {
    return { value: '48202', isDefault: true, codeType: CODE_TYPE_FALLBACK };
  }

  if (country === 'CA') {
    return { value: 'L1H8P7', isDefault: true, codeType: CODE_TYPE_FALLBACK };
  }
};

export const setCustomerLocationCookie = (
  postalCode,
  country,
  brand,
  zipCodeUrl
) => {
  if (country === 'CA') {
    putCookieObject(LOCATION_COOKIE, { zipcode: postalCode });
  }
  if (country === 'US') {
    const validatePostalCode = fetch(
      `${zipCodeUrl}/${postalCode}.json?brand=${brand}`
    ).then((res) => res.json());

    return validatePostalCode.then(function (validatedPostalCode) {
      putCookieObject(LOCATION_COOKIE, validatedPostalCode);
    });
  }
};
